import { ILead } from "../../../models/Lead";
import { IVehicle } from "../../../models/Vehicle";
import AwaitingInventoryStatusDropdown from "../../awaitingInventory/AwaitingInventoryStatusDropdown";
import PartsPriorityDropdown from "../../awaitingInventory/PartsPriorityDropdown";
import YardStatusDropdown from "../../awaitingInventory/YardStatusDropdown";
import CreateJobs from "../../jobs/CreateJobs";
import VehicleLocationDropdown from "../../vehicles/VehicleLocationDropdown";
import VehiclePartsCard from "../../vehicles/VehiclePartsCard";
import PartVehicleImages from "./LeadImagesCarousel";
import LeadJobs from "./LeadJobs";
import PartVehicleDetails from "./PartVehicleDetails";


export default function LeadParts({ lead, vehicle, }: { lead: ILead | null; vehicle: IVehicle | null; }) {


  return (
    <div className="mt-6 flex flex-col gap-y-4">
      {/* Status dropdowns */}
      {lead && (
        <div className="flex flex-col lg:flex-row text-sm text-gray-700 gap-4">
          <div className="flex flex-col">
            <p>Parts Status</p>
            <AwaitingInventoryStatusDropdown
              vehicle={lead.vehicle!}
              classes="pr-20"
            />
          </div>
          <div className="flex flex-col lg:mr-8">
            <p>Parts Priority Status</p>
            <PartsPriorityDropdown vehicle={lead.vehicle!} classes="pr-32" />
          </div>


          <div className="flex flex-col">
            <p>Yard Location</p>
            <VehicleLocationDropdown vehicle={lead.vehicle!} classes="pr-20" />
          </div>
          <div className="flex flex-col">
            <p>Yard Status</p>
            <YardStatusDropdown vehicle={lead.vehicle!} classes="pr-10" />
          </div>
        </div>
      )}

      {/* Only if we don't have a lead when we get here */}
      {!lead && vehicle && (
        <PartVehicleDetails
          vehicle={vehicle!}
          price={null}
          collectionQuestions
        />
      )}

      {lead && <PartVehicleImages lead={lead!} />}

      {lead && lead.jobs?.length! > 0 && <LeadJobs lead={lead} />}

      <VehiclePartsCard vehicleId={lead?.vehicleId!} />

      {/* <PartsRecall /> */}

      <CreateJobs lead={lead} vehicle={vehicle} />

    </div >
  );
}
